import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import {
  SECTION_ABN,
  SECTION_BUDGET,
  SECTION_CATEGORIES,
  SECTION_CLASSIFICATION,
  SECTION_TRANSACTIONS,
  SECTION_CHART,
  SECTION_REVOLUT,
  SECTION_ICS,
  SECTION_SWIBECO,
  SECTION_CREDIT_AGRICOLE,
  SECTION_CREDIT_MUTUEL_EUR,
  SECTION_CREDIT_MUTUEL_CHF,
  SECTION_REPORTING,
  SECTION_BAF,
  SECTION_SETTINGS,
  SECTION_BUNQ,
  SECTION_ASN,
  SECTION_UBS,
  SECTION_ABOUT,

  SECTION_HISTORY,
} from '../../constants/sections';
import ABN from './sections/ABN';
import Classification from './sections/Classification';
import Transactions from './sections/Transactions';
import Chart from './sections/Chart';
import Logo from './sections/Logo';
import Swibeco from './sections/Swibeco';
import ICS from './sections/ICS';
import Revolut from './sections/Revolut';
import CreditAgricole from './sections/CreditAgricole';
import CreditMutuelEUR from './sections/CreditMutuelEUR';
import Budget from './sections/Budget';
import Categories from './sections/Categories';
import CreditMutuelCHF from './sections/CreditMutuelCHF';
import Reporting from './sections/Reporting';
import BAFTable from './sections/BAFTable';
import Settings from './sections/Settings';
import Bunq from './sections/Bunq';
import ASNBank from './sections/ASNBank';
import UBS from './sections/UBS';
import About from './sections/About';

import History from './sections/History';

const getSection = (section, enabledBanks, setEnabledBanks) => {
  switch (section) {
    case SECTION_ABN:
      return <ABN />;
    case SECTION_CLASSIFICATION:
      return <Classification />;
    case SECTION_TRANSACTIONS:
      return <Transactions />;  
    case SECTION_CHART:
      return <Chart />;
    case SECTION_BUDGET:
      return <Budget />;
    case SECTION_CATEGORIES:
      return <Categories />;
    case SECTION_REVOLUT:
      return <Revolut />;
    case SECTION_ICS:
      return <ICS />;
    case SECTION_SWIBECO:
      return <Swibeco />;
    case SECTION_CREDIT_AGRICOLE:
      return <CreditAgricole />;
    case SECTION_CREDIT_MUTUEL_EUR:
      return <CreditMutuelEUR />;
    case SECTION_CREDIT_MUTUEL_CHF:
      return <CreditMutuelCHF />;
    case SECTION_REPORTING:
      return <Reporting />;
    case SECTION_BAF:
      return <BAFTable />;
    case SECTION_SETTINGS:
      return <Settings />;
    case SECTION_BUNQ:
      return <Bunq />;
    case SECTION_ASN:
      return <ASNBank />;
    case SECTION_UBS:
      return <UBS />;

    case SECTION_ABOUT:
      return <About />;
    case SECTION_HISTORY:
      return <History />;
    default:
      return <Logo />;
  }
};

export default function ASTIDashboardBody(props) {
  const { section, enabledBanks, setEnabledBanks } = props;

  return <Box>{getSection(section, enabledBanks, setEnabledBanks)}</Box>;
}

ASTIDashboardBody.propTypes = {
  section: PropTypes.string.isRequired,
  enabledBanks: PropTypes.arrayOf(PropTypes.string).isRequired,
  setEnabledBanks: PropTypes.func.isRequired,
};
